import './scripts/common';
import {onFind} from "@elements/init-modules-in-scope";

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

// Todo: Add page specific JS here e.g:
import * as lightbox from '@elements/lightbox';
lightbox.init();

import Collapse from 'bootstrap/js/dist/collapse';
onFind('[data-bs-toggle="collapse"]',function (element) {
    new Collapse(element);
});

import Tab from 'bootstrap/js/dist/tab';
onFind('[data-bs-toggle="tab"]',function (element) {
    new Tab(element);
});

import * as dynamicTabbing from './scripts/dynamic-tabbing';
dynamicTabbing.init();

import * as tabbingAnimations from './scripts/tabbing-animations';
tabbingAnimations.init();

import * as mobileCollapse from './scripts/mobile-collapse';
mobileCollapse.init();

import * as mixedTeaserScrollSlider from '@elements/scroll-slider';
mixedTeaserScrollSlider.init({
        dots: true,
        arrowIconClass: 'icon icon-arrow-right',
    },{
        base: '.js-scroll-slider-teaser',
        area: '.js-scroll-slider-teaser__area',
        item: '.js-scroll-slider-teaser__item',
        dotsContainer: '.js-scroll-slider-teaser__dots'
    }
);
onFind(".js-scroll-slider-teaser", function (element) {
    element.classList.add("scroll-slider-no-spacing-left") // WIP, to apply different slider styling only for content pages

    if(element.dataset.initialScrollToActiveSlide) {
        let activeSlide = element.querySelector('.active');
        let scrollArea = element.querySelector('.js-scroll-slider-teaser__area');

        activeSlide && scrollArea && scrollArea.scrollTo({
            left: activeSlide.offsetLeft,
            behavior: 'smooth'
        });
    }
})